import {
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    Divider,
} from "@nextui-org/react";

import { useParams } from "react-router-dom";
import { BiSolidVideos } from "react-icons/bi";
import { MdDelete } from "react-icons/md";

import Button from "@/components/Button";
import Modal from "@/components/Modal";
import ConfirmDelete from "@/components/ConfirmDelete";
// import { secondsToTime } from "@/utils/helpers";

import VideoView from "./VideoView";
import UpdateLectureItem from "./UpdateLectureItem";
import { useDeleteLectureItem } from "../hooks/useDeleteLectureItem";
import usePermission from "../../../../hooks/usePermission";

function VideoCard({ videoItem }) {
    const { can } = usePermission();

    const { courseId, lectureId } = useParams();

    const { name, brief, type, videoViews } = videoItem.attributes;
    const { id } = videoItem;

    const { deleteLectureItem, isDeleting } = useDeleteLectureItem();

    return (
        <>
            <Card className="w-[298px] h-[275px] pt-3">
                <CardHeader className="flex items-center justify-between">
                    <div className="flex gap-3">
                        <BiSolidVideos className="text-4xl text-yellow-400" />
                        <div className="flex flex-col">
                            <p className="text-sm">{name}</p>
                            <p className="text-small text-default-500">فيديو</p>
                        </div>
                    </div>

                    {can("delete:course:lecture:items") && (
                        <Modal>
                            {/* Modal For Delete Video */}
                            <Modal.Open opens={`delete-${id}`}>
                                <button>
                                    <MdDelete className="text-3xl transition-all duration-300 text-red-color-primary hover:text-red-900" />
                                </button>
                            </Modal.Open>
                            <Modal.Window name={`delete-${id}`}>
                                <ConfirmDelete
                                    resourceName={name}
                                    disabled={isDeleting}
                                    onConfirm={() =>
                                        deleteLectureItem({
                                            courseId,
                                            lectureId,
                                            itemId: id,
                                        })
                                    }
                                />
                            </Modal.Window>
                        </Modal>
                    )}
                </CardHeader>

                <Divider />

                <CardBody className="text-right">
                    <p className="pt-2">
                        نبذه عن الفيديو :
                        <span className="text-gray-color-primary">{brief}</span>
                    </p>
                </CardBody>

                <CardFooter className="justify-between">
                    <Modal>
                        {/* Modal For Update Video */}
                        {can("update:course:lecture:items") && (
                            <>
                                <Modal.Open opens={`update-${id}`}>
                                    <Button type="primary">تعديل</Button>
                                </Modal.Open>

                                <Modal.Window name={`update-${id}`}>
                                    <UpdateLectureItem
                                        courseId={courseId}
                                        lectureId={lectureId}
                                        itemId={id}
                                        name={name}
                                        brief={brief}
                                        type={type}
                                        videoViews={videoViews}
                                    />
                                </Modal.Window>
                            </>
                        )}

                        {/* Modal For View Video */}
                        <Modal.Open opens={`view-${id}`}>
                            <Button type="primary">افتح الفيديو</Button>
                        </Modal.Open>

                        <Modal.Window name={`view-${id}`}>
                            <VideoView name={name} itemId={id} videoId={id} />
                        </Modal.Window>
                    </Modal>
                </CardFooter>
            </Card>
        </>
    );
}

export default VideoCard;
